export default "__VITE_ASSET__Bs3op2Wx__"